module.exports = __webpack_public_path__ + "static/media/agricultural15.c6193bee.jpg";